export const GET_HOME_CONTENT = 'GET_HOME_CONTENT';